import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../utils';
import {
  APP_ID,
  APP_VERSION,
  OTP_FOR_MOB_CHANGE,
} from '../../../utils/constants/index';

import { useEditProfileStore } from '../../index';

export const MobileUpdateApi = createAsyncThunk(
  'MobileUpdate',
  async (mobileUpdatePayload, { dispatch }) => {
    console.log('mobileUpdatePayload called', mobileUpdatePayload);
    dispatch({ type: 'MobileUpdate/pending', payload: {} });

    const {
      customerId,
      Authorization,
      customerRefNum,
      mobileNumber,
      otpCode,
      templateType,
    } = mobileUpdatePayload;

    // const { SubmitProfileDetailsApi } = useEditProfileStore();
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'dashboardmenus/edit_profile/mobile_update',
      payload: {
        customerRefNum,
        profileOtpReqModel: {
          mobileNumber,
          otpCode,
          reqType: 'mobile',
          templateType,
          // templateType: OTP_FOR_MOB_CHANGE
        },
        type: 'mobile',
        appId: APP_ID,
        appVersion: APP_VERSION,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        dispatch({ type: 'MobileUpdate/fulfilled', payload: res });
        // SubmitProfileDetailsApi({
        //   customerId,
        //   Authorization,
        //   customerRefNum,
        //   type: 'mobile',
        //   templateType: OTP_FOR_MOB_CHANGE,
        //   otpCode,
        //   contactDetails: {
        //     mobileNumber
        //   }
        // })
      },
      errorFn: (err) => {
        debug('ERROR', `Error from MobileUpdate: `, err);
        dispatch({ type: 'MobileUpdate/rejected', payload: err });
      },
    });
  }
);

export const MobileUpdate_extrareducer = {
  [MobileUpdateApi.pending]: (state, action) => {
    state.mobileUpdateApiState.isLoading = true;
  },
  [MobileUpdateApi.fulfilled]: (state, action) => {
    state.mobileUpdateApiState.isLoading = false;
    state.mobileUpdateApiState.isSuccess = true;
    state.mobileUpdateApiState.isError = false;
    state.mobileUpdateApiState.response = action.payload;
  },
  [MobileUpdateApi.rejected]: (state, action) => {
    state.mobileUpdateApiState.isLoading = false;
    state.mobileUpdateApiState.isSuccess = false;
    state.mobileUpdateApiState.isError = true;
    state.mobileUpdateApiState.response = action.payload;
  },
};
